import { render, staticRenderFns } from "./SpecializationInfoNurse.vue?vue&type=template&id=181bb1ac"
import script from "./SpecializationInfoNurse.vue?vue&type=script&lang=js"
export * from "./SpecializationInfoNurse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports